<template>
  <div v-if="results" class="event-cards">
    <Carsousel type="Event" :payload="results" :settings="settings"></Carsousel>
  </div>
</template>

<script>
import algoliasearch from 'algoliasearch';
import Carsousel from '../carousel-layouts/Carousel.vue';

export default {
	props: {
		'id': {
			type: String
		},
		'esc_route' : {
			type: String
		}
	},

  components: {
    Carsousel
  },

  data() {
		var date_min = Date.now();
		var date_max = Date.now();

		date_min -= (1000 * 60 * 60 * 4); // 4 Hours Earlier
		date_max += (1000 * 60 * 60 * 24 * 365 * 5) // 5 Years Ahead

    return {
			client: false,
			index: false,
			index_name: (this.$config.test_env) ? 'events-dev' : 'events-live',
			searchObject: {
				hitsPerPage: 3,
				facets: ["esc-route"],
				facetFilters: [[`esc-route:${this.esc_route}`]],
				numericFilters: [["event-date:" + date_min + " TO " + date_max]]
			},
			results: false,
    }
  },

	created() {
		this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
		this.index = this.client.initIndex(this.index_name);

		this.index
			.search('', this.searchObject)
			.then((results) => {
				console.log("Similar events raw results:", results);
				if (results.nbHits > 0) {
					this.filteredResults = results.hits.filter((el) => {
						return el['id'] !== this.id;
					});
					this.results = this.filteredResults.length ?  this.filteredResults : false;
				} else {
					this.results = false;
				}
			});
	},

  computed: {
    settings() {
      return {
        width: '100%',
        gap: '1rem',
        pagination: false,
        arrows: false,
        perPage: 4,
        breakpoints: {
          640: {
            perPage: 1,
            drag: this.results.length >= 1
          },
          1024: {
            perPage: 2,
            drag: this.results.length >= 2
          },
          1280: {
            perPage: 3,
            drag: this.results.length >= 3
          },
          1536: {
            perPage: 4,
            drag: this.results.length >= 4
          },
        }
      }
    }
  }
}
</script>
